import { render, staticRenderFns } from "./ChronotachographHistories.vue?vue&type=template&id=60a5550e&scoped=true&"
import script from "./ChronotachographHistories.vue?vue&type=script&lang=js&"
export * from "./ChronotachographHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5550e",
  null
  
)

export default component.exports